import React, { Component } from 'react';
import { connect } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "../common.css";
import SettingsPage from './SettingsPage';
import ReviewPage from './ReviewPage';

class MainPage extends Component {
    render() {
        return (
            <div className="form main_page">
                <Tabs>
                    <TabList>
                        <Tab>Reviews</Tab>
                        <Tab>Settings</Tab>
                    </TabList>
                    <TabPanel>
                        <ReviewPage/>
                    </TabPanel>
                    <TabPanel>
                        <SettingsPage/>
                    </TabPanel>
                </Tabs>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.loading.loading
});

export default connect(mapStateToProps)(MainPage);